import React, { useEffect } from 'react';
import './../styles/site.css';
import './../styles/site/ty.css';
import NavbarTop from './site/Navbartop';
import Footer from './site/Footer';
import { Link } from 'react-router-dom';
import * as globals from "./../components/GlobalScripts.js";

const TY = () => {

    useEffect(() => {
        const fetchFacebookData = async () => {
            let facebookParams = globals.facebookParams();
            let event_source_url = facebookParams.event_source_url;
            let client_user_agent = facebookParams.client_user_agent;
            let event_time = facebookParams.event_time;
            let facebookPixel = facebookParams.facebookPixel;
            let facebookToken = facebookParams.facebookToken;
            let event_id = facebookParams.event_id;

            let data = {
                "event_source_url": event_source_url,
                "event_time": event_time,
                "client_user_agent": client_user_agent,
                "hostedBy": "Zadrig"
            };

            await window.fbq('track', 'PageView', data, { eventID: event_id });

            let fbp = facebookParams.fbp;
            let fbc = facebookParams.fbc;

            await fetch('https://zadrig.com/facebook/eventos/danithor/pageview.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    event_id: event_id,
                    facebookPixel: facebookPixel,
                    facebookToken: facebookToken,
                    event_time: event_time,
                    fbp: fbp,
                    fbc: fbc,
                    event_source_url: event_source_url,
                    client_user_agent: client_user_agent
                }),
            });
        };

        fetchFacebookData();
    }, []);

    return (
        <div className="app-site app-container">
            <NavbarTop />
            <div className="main-content page-ty">
                <div className="page-container">
                    <div className='container-section medium-section flex-column center gap-40 banner'>
                        <h1>¡Gracias por tu compra!</h1>
                        <Link className='button-primary' to="/quest">Quiero comenzar ahora</Link>

                        <p>Llenarás un pequeño cuestionario para poder preparar tu personalización</p>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default TY;
